import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import MetriCard from './components/MetriCard'
//import { FaClipboardList, FaUsers } from 'react-icons/fa'
import Projects from "./assets/projects.png"
import Projects2 from "./assets/projects2.png"
import Workers from "./assets/workers.png"
import Ocupancy from "./assets/ocupancy.png"
import Health from "./assets/health.png"
import BIA from "./assets/BIA.png"
import Porfolio from "./assets/portfolio.png"
import GaugeCard from './components/GaugeCard'
import LineChartCard from './components/LineChartCard'
import BarChartCard from './components/BarChartCard'
import HealthStatusCard from './components/HealthStatusCard'
import PortfolioCard from './components/PortfolioCard'
import styles from './DeliveryDashboard.module.css'
import { API_ROUTE, headersRequest } from "../../helpers";
import axios from 'axios'
import ReactDatePicker from "react-datepicker";
import { CircularGauge } from 'devextreme-react'
import { RangeContainer, Scale ,Range } from 'devextreme-react/cjs/circular-gauge'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { DeliveryDashboardServices } from './DeliveryDashboardServices'
import _ from 'lodash'

const palette = [
  "#AD1B02",  // 0 Rojo PwC
  "#000000",  // 1 Negro
  "#D85604",  // 2 Terracota
  "#E88D14",  // 3 Naranja claro
  "#F3BE26",  // 4 Amarillo
  "#E669A2",  // 5 Rosa
  "#FFFFFF",   // 6 Blanco
  "#99CF16", // 7  Verde claro
  "#4FA0CA", // 8  Azul claro
 "#cda836de", // 9  Verde oscuro
  "#f48501", // 10  Azul fuerte
];

const capacityInstalled= 101 // listo
 const totalProjects= 24 ; // listo
 const _occupancyData=[ // listo
    { label: 'CLUSTER 1', value: 50 },
    { label: 'CLUSTERCLUSTER 2',      value: 90 },
    { label: 'CLUSTERCLUSTER 3',       value: 85 },
    { label: 'CLUSTER 4', value: 70 },
    { label: 'CLUSTER 5',      value: 30 },
    { label: 'CLUSTER 6',       value: 90 },
  ];
  const _biaData = {
    planned: [ { month: 'Ene', value: 1000 },{ month: 'Feb', value: 1500 },{ month: 'Mar', value: 1650 },{ month: 'Abr', value: 1800 },{ month: 'May', value: 2000 },{ month: 'Jun', value: 2500 },{ month: 'Jul', value: 2000 }],
    real:    [ { month: 'Ene', value: 800},{ month: 'Feb', value: 1200 },{ month: 'Mar', value: 1400 },{ month: 'Abr', value: 1700 },{ month: 'May', value: 2300 },{ month: 'Jun', value: 2100 },{ month: 'Jul', value: 1900 }]
  };
  const _stageData=[
    { stage: 'Planeación', count: 7 },
    { stage: 'Ejecución',  count: 6 },
    { stage: 'Cierre',     count: 11 },
  ];
  const _healthData=[
    { name: 'GEB',             real: 20, plan: 20 },
    { name: 'DIAN',            real: 70, plan: 100 },
    { name: 'Rama Judicial',   real: 15, plan: 10 },
    { name: 'Fondo Adaptación', real: 100, plan: 100 }
  ];
  const portfolioMetrics = [
    { label: 'Tiempo',       colorIndex: 0 },
    { label: 'Entregables',  colorIndex: 1 },
    { label: 'Facturación',  colorIndex: 2 },
    { label: 'Administrativa', colorIndex: 3 },
    { label: 'Rentabilidad', colorIndex: 4 }
  ];

  // const monthNames = {
  //   '01': 'Ene', '02': 'Feb', '03': 'Mar', '04': 'Abr',
  //   '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Ago',
  //   '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dic',
  // };
  const getDay = ()=>{
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const from_date = new Date(year, month, 1);
    const to_date = new Date(year, month + 1, 0);
    return {
      start_date : from_date,
      end_date : to_date
    }
  }
  
  const InitialState = {
    start_date:  getDay().start_date,
    end_date:  getDay().end_date,
  };

const DeliveryDashboard = () => {
  const [capacityProjects, setCapacityProjects] = useState([]);
  const [stageData, setStageData] = useState([]);
  const [healthData, setHealthData] = useState([]);
  const [occupancyData, setOccupancyData] = useState([]);
  const [dataBIA, setDataBIA] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dataFilter, setDataFilter] = useState([])
  const [dates, setDates] = useState({})
  const [loading, setLoading] = useState(false)

  let history = useHistory();

  const getDataDashboard = async () =>{
      try {
          const res = await axios.get(`${API_ROUTE}delivery-info`, headersRequest());
          const {
            capacityProjects: cp = [],
            stageData: sdRaw = [],
            healthData: hd = [],
            occupancyData: od = [],
            dataBIA: bia = [],
          } = res.data;
          
          const sd = sdRaw.map(({Estado, Total}) =>({
            stage:Estado,
            count:Total
          }));

          //const biaData = convertToBiaData(biaRaw);

          setCapacityProjects(cp[0]);
          setStageData(sd);
          setDataBIA(bia)
      } catch (err) {
      console.error('Error cargando dashboard delivery:', err);
    }
  };

  const ocupationCluster = async (state) =>{
    try {
      const result = await DeliveryDashboardServices.getOcupationByCluster(state)
      if(result){
          setDataFilter(result.dataFilter)
          const dataClusterForm = result.dataCluster.map((cluster)=>{
            return {...cluster,
              value : cluster.occupancy,
              label : cluster.cluster
            }
          })
          setOccupancyData(dataClusterForm)
      }
      
    } catch (error) {
      throw new Error("error",error);
    }

  }

  const strategyProjectsByOrg = async () =>{
    try {
      setLoading(true)
      const result = await DeliveryDashboardServices.getProjects()
      if(result){
          const strategyProjects = _.chain(result).filter(pr => pr.CostoPlaneado != null).orderBy(['CostoPlaneado'],['desc']).take(3).value()
          setHealthData(strategyProjects)
      }
    } catch (error) {
      throw new Error("error",error);
      
    } finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    getDataDashboard();
    ocupationCluster(InitialState)
    strategyProjectsByOrg()
  }, []);
  
const palette_alt = [
  "#99CF16", // Verde claro
  "#F3BE26", // Amarillo
  "#ff1111", // Rojo PwC
  "#000", // negro
];

  const getGaugeColor = (value) => {

  if (value <= 50) return palette_alt[0]; // verde
  if (value <= 80)  return palette_alt[1]; // amarillo
  if (value <= 100)  return palette_alt[2]; // rojo
  return palette_alt[3]; 
};


  const handleViewGauge = (view)=>{
    if(view.label && view.idCluster){
      history.push(`/pharos-cluster-dashboard/${view.label}/${view.idCluster}`)
    }
    return
  }

  
  const formaDate = (date) => {
    if(date){
    const dat = date?.split("T")[0].split("-");
    return `${dat[2]}-${dat[1]}-${dat[0]}`;

    }

  };

  const handleFilterOccupancy = async () => {
    const datesDos = {
      start_date: startDate,
      end_date:endDate,
    }
    try {
      await ocupationCluster(datesDos)
      
    } catch (error) {
      console.error(error)
    }
     
  }

  return (
<Container fluid className="dashboard-grid" style={{maxWidth:'1440px'}}>
    <Row className="mb-5">
      <Col xs={12} md={2}>
        <MetriCard
          icon={<img src={Workers} />}
          value={capacityProjects?.CapacidadInstalada}
          label="Capacidad Instalada"
          bgColor={palette[9]}
          textColor="#fff"
          styles={styles}
        />
      </Col>
      <Col xs={12} md={2}>
        <MetriCard
          icon={<img src={Projects} />}
          value={capacityProjects?.CantidadProyectos}
          label="Total Proyectos"
          bgColor={palette[10]}
          textColor="#fff"
          styles={styles}
        />
      </Col>
      <Col xs={12} md={8}>
        <LineChartCard
          title="Gestión BIA"
          dataRecords={dataBIA}
          styles={styles}
          img={<img src={BIA} />}
        />
      </Col>
    </Row>

    <Row className="mb-5">
      <Col md={12}>
          <Card className={styles.boxShadow} style={{ height: '100% !important', cursor:'pointer' }}>
            <Card.Header className={styles.CardHeader}>
              {<img src={Ocupancy}/>}"Promedio ocupación Delivery"
            </Card.Header>
            <Card.Body className={styles.gaugeContainer}>
              <Col md={12}>
                <div className="d-flex align-items-center">
                  <Col md={8} className="d-flex">
                    <Col md={6} className="pl-0">
                      <ReactDatePicker
                        style={{ height: "32px" }}
                        selected={startDate}
                        dateFormat="dd/MM/yyyy"
                        filterDate={(date) =>
                          date.getDay() !== 6 && date.getDay() !== 0
                        }
                        wrapperClassName="w-100"
                        className="form-control"
                        locale={
                          window.localStorage.getItem("idioma") === "es"
                            ? "es"
                            : "en"
                        }
                        todayButton={
                          window.localStorage.getItem("idioma") === "es"
                            ? "Hoy"
                            : "Today"
                        }
                        required={endDate ? true : false}
                        /*   disabled={filter.Idrol == "0" ? true : false} */
                        placeholderText="Desde"
                        name="startDate"
                        fixedHeight={false}
                        onChange={(date) => {
                          setStartDate(date);
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <ReactDatePicker
                        selected={endDate}
                        dateFormat="dd/MM/yyyy"
                        filterDate={(date) =>
                          date.getDay() !== 6 && date.getDay() !== 0
                        }
                        wrapperClassName="w-100"
                        className="form-control"
                        style={{ height: "32px" }}
                        placeholderText="Hasta"
                        name="endDate"
                        fixedHeight={false}
                        today
                        required={startDate ? true : false}
                        minDate={startDate}
                        locale={
                          window.localStorage.getItem("idioma") === "es"
                            ? "es"
                            : "en"
                        }
                        todayButton={
                          window.localStorage.getItem("idioma") === "es"
                            ? "Hoy"
                            : "Today"
                        }
                        //locale = "es"
                        onChange={(date) => {
                          setEndDate(date);
                        }}
                      />
                    </Col>
                  </Col>
                  <Col md={3}>
                    <Button
                      variant="outline-primary"
                      className=""
                      onClick={handleFilterOccupancy}
                     /*  type="submit" */
                      size="sm"
                    >
                      <i className="fa far fa-search" />
                    </Button>
                  </Col>
                </div>
              </Col>
              <Col className='d-flex align-items-center flex-column'>
              <div>
                 <b> Periodo de Ocupación: {formaDate(dataFilter[0]?.start_date)} - {formaDate(dataFilter[0]?.end_date)}</b>
              </div>
              <div className='d-flex'>
              {occupancyData.map((d, i) => {
                const color = getGaugeColor(d.value);
                return (
                  <div onClick={()=>handleViewGauge(d)} key={d.label} className={styles.gaugeItem}>
                    <CircularGauge
                      id={`gauge-${i}`}
                      size={{ width: 170, height: 150 }}
                      value={d.value}
                    >
                      <Scale
                        startValue={0}
                        endValue={ Math.max(100, ...occupancyData.map(d => d.value)) * 1.2}
                        startAngle={220}
                        endAngle={-20}
                        tickInterval={20}
                        label={{
                          font: {
                            color: '#333',
                            weight: 600,
                            size: 12
                          }
                        }}
                      />
      
                      <RangeContainer backgroundColor="#f0f0f0" width={10}>
                        <Range startValue={0} endValue={d.value} color={color} />
                      </RangeContainer>
                    </CircularGauge>
      
                    <div className={styles.gaugeLabel}>
                      <strong>{d.value}%</strong>
                      <div>{d.label}</div>
                    </div>
                  </div>
                );
              })}
              </div>
              </Col>
            </Card.Body>
          </Card>
      </Col>
    </Row>
    <Row className="mb-5">
      <Col sm={12} md={12}>
        <Row>
          <Col xs={12} md={6}>
            <HealthStatusCard
              title="Estado de salud proyectos estratégicos"
              projects={healthData}
              styles={styles}
              loading={loading}
              img={
                <img src={Health} />
                }
            />
          </Col>
          <Col xs={12} md={6}>
            <Row className="mb-4">
              <Col md={12}>
                <BarChartCard
                  title="Total Proyectos por etapa"
                  data={stageData}
                  styles={styles}
                  img={<img src={Projects2} />}
                />
              </Col>
            </Row>
            <Row className="">
              <Col md={12}>
                <PortfolioCard
                  title="Gestión Portafolio"
                  metrics={portfolioMetrics}
                  styles={styles}
                  img={<img src={Porfolio} />}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>

  </Container>
  )
}

export default DeliveryDashboard